import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import IMigrationForm from '@/ui/views/old-login/migration.form.interface';
import UsernameRequirementsText from '@/ui/shared/UsernameRequirementsText.vue';
import PasswordRequirementsText from '@/ui/shared/PasswordRequirementsText.vue';
import { useTranslations } from '@/core/translate.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'MigrationFormModal',
  props: {
    showModal: { type: Boolean },
    username: null,
    userNameError: { type: Boolean },
    errorMessage: null,
    showSpinner: { type: Boolean },
    showSkipButton: { type: Boolean },
    showConfirmationMessage: { type: Boolean }
  },
  emits: ['submit', 'skip', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
    showModal: boolean;
    username: string;
    userNameError: boolean;
    errorMessage: string;
    showSpinner: boolean;
    showSkipButton: boolean;
    showConfirmationMessage: boolean;
}

const formData = ref<IMigrationForm>({
    username: null,
    password: null,
    confirmPassword: null
});



const customUsernameError = ref<string>('');
watch(() => formData.value.username, () => {
    customUsernameError.value = '';
});
watch(() => props.userNameError, () => {
    customUsernameError.value = t('Pages.PartnerPortal.Login.LoginPage.Migration.UsernameInvalidMessage');
});

const { t } = useTranslations();


const onSubmit = () => emit('submit', formData.value);
const onSkip = () => emit('skip');
const onClose = () => emit('close');

return { __sfc: true,formData, props, customUsernameError, t, emit, onSubmit, onSkip, onClose, UsernameRequirementsText, PasswordRequirementsText }
}

})